/**
 * Signal Scan Lesson
 * Skill Area: Leadership
 * Filter AI noise with strategic assessment
 */

import type { LessonDefinition } from '../types';
import {
  SIGNAL_SCAN_AI_PROMPT,
  SIGNAL_SCAN_CONTEXT_SCENARIOS,
} from '../prompts/signal-scan.prompt';

export const signalScan: LessonDefinition = {
  id: 'signal-scan',
  title: 'Signal Scan',
  displayTitle: 'Filter AI Noise with Strategic Assessment',
  subTitle: 'Decide if an AI headline matters now.',
  tagline: 'Spot what matters and choose a next move.',
  persona: 'Lyra',
  skillArea: 'Leadership',
  format: 'pulse',
  difficulty: 'Intermediate',
  estimatedMinutes: 6,
  tags: ['trends', 'strategy', 'filters'],
  dailyEligible: false,
  releasedAt: '2025-02-01T00:00:00.000Z',
  route: '/micro/signal-scan',
  storyBeat: 'Lyra gives you a quick read on signal vs noise.',
  contextTitle: 'Signals to practice with',
  contextSummary:
    "Grab the kind of headline or rumor you're seeing and Lyra will help you score it.",
  contextScenarios: SIGNAL_SCAN_CONTEXT_SCENARIOS,
  introPrompt:
    "AI noise is distracting. I'll explain why filtering matters, show you a Signal Scan comparison, and help you score a recent headline.",
  steps: [
    'Name a confusing AI headline',
    'See a "Hype vs. Strategy" comparison',
    'Score the signal: Test, Watch, or Skip',
  ],
  promptGuidance: 'Choose a trend below or type your own.',
  aiPrompt: SIGNAL_SCAN_AI_PROMPT,
  inputPlaceholder: "Type 'New Model' or your own trend...",
  quickPrompts: ['New Fancy Model', 'Privacy Policy Change', 'Vendor Sales Pitch'],
};
